module.exports = __webpack_public_path__ + "aaadf2c9680cceee07bb62b3555222be.jpg";